import {AuthorizationFetcher, utils} from '@wallaby-ui/core';

/** @deprecated */
const HierarchyFetcher = {
  get(requestUrl, params) {
    let paramString = `type=${encodeURIComponent(params.type)}`;
    if (params.id) {
      paramString += `&id=${encodeURIComponent(params.id)}`;
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}?${paramString}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  getHierarchyChildren(requestUrl, params) {
    let paramString = `type=${encodeURIComponent(params.hierarchyId)}`;
    if (params.parentId) {
      paramString += `&parentId=${encodeURIComponent(params.parentId)}`;
    }
    if (params.page) {
      paramString += `&page=${encodeURIComponent(params.page)}`;
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}?${paramString}&projection=tree`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  getHierarchyTypes(requestUrl) {
    return AuthorizationFetcher.interceptedFetch(
      requestUrl,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },
};

export default HierarchyFetcher;
